var nw_overlay = {
    enabled:  false,
    nw_middleware_enabled: false,

    init: function(){
      var popup = Cookies.get('nw_popup');

      if (popup == 'open' || Shopify.designMode === true) {
        return false;
      } else {
        this.open();
      }

      if(this.nw_middleware_enabled) $('#newsletter_modal').attr('action', "javascript:;");
    },
    open: function(){
        var expire = parseInt(10);

        $('#newsletter-overlay').on('shown.bs.modal', function () {
            Cookies.set('nw_popup', 'open', { expires: expire });
        });

        setTimeout(() => {
            $('#newsletter-overlay').modal('show');
        }, 5000);

        this.eventListener();

    },
    checkPopupUrl: function(){
        var pages_disabled = ["\/blogs\/projects\/ethiotrees","\/pages\/beauty-for-you-and-the-planet"];
        var path = window.location.pathname;
        var skip = false;
        for(i in pages_disabled){
            if(path == pages_disabled[i]){
                skip = true;
                break;
            }
        }

        if(!skip && this.enabled){
            this.init();
        }

    },
    eventListener: function (){
        var $btn = $('#newsletter-overlay form').find('button[type="submit"]');

        document.addEventListener('submitNewsletter', function () {
            $btn.prop("disabled", false);
        }, false);
    }

}




      GTM.newsletter_position = 'popup';



    function setPosition_Header() {
        GTM.newsletter_position = 'header';

    }



    function setPositionFooter() {
        GTM.newsletter_position = 'footer';

    }

var MiddlewareNw = false;

if(MiddlewareNw){
    $('#newsletter_modal').submit(function(e){
        var $form = $(this);
        e.preventDefault();
        $form.removeAttr("onsubmit"); //avoid shopify recaptcha injection
        middlewareRequest($form);
    });
} else {
    $('#newsletter_modal').submit( function(event){
        if($('#nw-radio-1').prop('checked')){
            $('#contact-tags').val($('#contact-tags').val() + ',' + 'userType_consumer');
        }else{
            $('#contact-tags').val($('#contact-tags').val() + ',' + 'userType_stylist');
        }

    });
}

  var themeLazyLoad = {
    init: function() {
        var $elems = $('[data-lazy]').not('img');

        if($elems.length>0 && typeof $elems.waypoint === 'function'){
            $elems.waypoint(function() {
                var $el = $(this.element);
                var urlToLoad = $el.data('lazy');
                // If setted loads mobile image under 480px
                if($(window).width() <= 480 && $el.data('lazyMobile') != '' && $el.data('lazyMobile') != undefined) {
                    urlToLoad = $el.data('lazyMobile');
                }
                var elImage = new Image();
                elImage.src = urlToLoad;
                elImage.onload = function() {
                    $el.css({
                        'backgroundImage': 'url(' + elImage.src + ')'
                    });
                    $el.addClass('lzloaded');
                    setTimeout(function() {
                        $el.addClass('lzloaded');
                    }, 150);
                };
            }, {
                offset: '90%'
            });
        }


        var $elemsV = $('[data-lazy-iframe]');

        if($elemsV.length>0 && typeof $elemsV.waypoint === 'function'){
            $elemsV.waypoint(function() {
                var $el = $(this.element);
                var urlToLoad = $el.data('lazy-iframe');
                $el.prop('src', urlToLoad);
            }, {
                offset: '90%'
            });
        }

        var $elemsImg = $('[data-lazy-img]');
        if($elemsImg.length>0 && typeof $elemsImg.waypoint === 'function'){
            $elemsImg.waypoint(function() {
                var $el = $(this.element);
                var urlToLoad = $el.data('lazy-img');
                var elImage = new Image();
                elImage.src = urlToLoad;
                elImage.onload = function() {
                    $el.attr("src", elImage.src);
                    $el.addClass('lzloaded');
                };
            }, {
                offset: '100%'
            });
        }
    }
};

var anchorsMenu = {

    init: function(){

        var $el = $('.anchors-menu'),
            $anchors = $el.find('a'),
            $targets = $el.nextAll()
            elHeight = $el.outerHeight();


        if($el.length>0 && typeof $el.waypoint === 'function' ){


            $el.waypoint(function(direction) {

                var toggle = (direction=='down');
                    // $stickyNav = $('.sticky_nav');

                // if(toggle && !$stickyNav.hasClass('sticky_nav--stick')){
                //     toggle = false;
                //     console.log("reveeeert!");
                // }

                $clone.toggleClass('visible',(toggle));

            }, {
                offset: (elHeight*-1)
            });

            $anchors.click({$targets:$targets},function(){
                $this = $(this);


                var offset = (($(window).width() <= 798) ? 45 : 70) + elHeight;


                goToPos($($targets[$this.index()]), offset);

            });
            var $clone = $el.clone(true).addClass('sticky-top');
            $clone.insertAfter($el);
        }

    }
}




function goToPos(ref,offset){

    var defaultOffset = ($(window).width() <= 798) ? 45 : 70;

    if(typeof offset === 'undefined') offset = defaultOffset;
    $ref = (typeof ref === 'string') ? $(ref) : ref ;
    if($(ref).length == 0)
      //return false;
      $ref = $("body");

    var myPos = $ref.offset().top-offset;

    function getDuration(target) {
        var minDuration = 300;
        var currentTop = $(window).scrollTop(),
        rate = 0.3,
        distance = Math.abs(currentTop - target);
        ret = distance * rate;
        return (ret > minDuration) ? ret : minDuration ;
    }


    $('html,body').animate({
      scrollTop: myPos},
      { duration: getDuration(myPos) }
    );
}

function middlewareRequest(form) {
    var $form = form;
    $form.removeAttr("onsubmit"); //avoid shopify recaptcha injection
    $form.find('button[type="submit"]').prop("disabled", true);
    var res = $form.serializeArray(),
            tags = [],
            email,
            name,
            phone,
            type,
            cookies,
            privacy;

            // Collect data for middleware
            for(i in res){
                switch (res[i].name) {
                    case 'nw-email':
                    case 'contact[email]':
                        email = res[i].value;
                        break;

                    case 'nw-type':
                    case 'contact[userType]':
                        type = res[i].value;
                        break;

                    case 'nw-name':
                    case 'contact[first_name]':
                        name = res[i].value;
                        break;

                    case 'nw-phone':
                    // case 'contact[phone]':
                    case 'customer[full_phone]':
                        phone = res[i].value;
                        if(phone && phone.length > 0) {
                            tags.push('userPhoneNumber_' + phone);
                        }
                        break;

                    case 'nw-privacy':
                        privacy = res[i].value;
                        break;

                    case 'nw-cookies':
                        cookies = res[i].value;
                        if(cookies == 'true') {
                            tags.push('userAcceptCookie_true');
                        } else {
                            tags.push('userAcceptCookie_false');
                        }
                        break;

                    // case 'customer[sms]':
                    //     if (phone && phone.length > 0) {
                    //         tags.push('userAcceptSMS_false');
                    //     }
                    //     break;
                }
            }

            // if tags array doesn't contain userAcceptCookie_ tag, add userAcceptCookie_false
            if (!tags.includes('userAcceptCookie_true') && !tags.includes('userAcceptCookie_false')) {
                tags.push('userAcceptCookie_false');
            }

            // Send data to middlweare
            middleware.newsletter.register(tags.join(','),email,privacy,name,type,cookies,false,$form);
};

var MDCFixAutocomplete = function(passedElement){
    // myTimeOut = setTimeout(function(){
    //   passedElement.dispatchEvent(new Event('focus'));
    // }, 500);
}

function MDCForms(){
    // Init inputs MDC
    var inputArr = document.querySelectorAll('.mdc-text-field');
    for (var i = 0; i < inputArr.length; i++) {
        mdc.textField.MDCTextField.attachTo(inputArr[i]);
    }

    // Selects MDC
    var selArr = document.querySelectorAll('.mdc-select');
    var $selArr = $('.mdc-select');
    var mdc_Component = document.querySelectorAll('.mdc-select__selected-text');

    // Manually trigger change for floating label as we don't use anymore the mdc plugin but only the graphics
    $selArr.find('select').change(function(){
        var $el = $(this);
        var $label = $el.siblings('.mdc-floating-label');
        if($el.val()!=''){
            $label.addClass('mdc-floating-label--float-above');
        }
    });

    for (var i = 0; i < selArr.length; i++) {

       if (mdc_Component.length) {

        mdc.select.MDCSelect.attachTo(selArr[i]);

       }
    }

    setTimeout(function(){
        $.each($('input:-webkit-autofill'), function() {
            $(this).siblings('.mdc-floating-label').addClass('mdc-floating-label--float-above');
        });
    }, 500);





    // Fix autofocus MDC
    /* var inputArrFix = document.querySelectorAll('.mdc-text-field__input');
    for (var i = 0; i < inputArrFix.length; i++) {
        inputArrFix[i].dispatchEvent(new Event('focus'));
    }*/
}

var addBodyBrowserClass = {

    init: function(){

        this.addClass();

    },

    addClass: function(){

        // Opera 8.0+
        var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

        // Firefox 1.0+
        var isFirefox = typeof InstallTrigger !== 'undefined';

        // Safari 3.0+ "[object HTMLElementConstructor]"
        var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;

        // Edge 20+
        var isEdge = !isIE && !!window.StyleMedia;

        // Chrome 1 - 71
        var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

        // Blink engine detection
        var isBlink = (isChrome || isOpera) && !!window.CSS;

        if(isEdge){
            $('body').addClass('browser-edge');
        }


    }

}

function toggleElement(selector, condition, displayValue) {
  if ($(selector).length) {
      $(selector).css('display', condition ? displayValue : 'none');
  }
}


var faqBox = {
  init: function(){
      var $items = $('.faq-box__item'),
          $itemsText = $('.faq-box__text');

          $itemsText.slideUp(0);

      $('body').on('click', '.faq-box__item-title', function(e) {
          var $this = $(this),
              $item = $this.parent(),
              $text = $this.next();

          if ($this.hasClass('faq-box__item-title-sachet')) {
              const headerHeight = $('header').innerHeight();
              if (navigator.userAgent.match(/iPhone/i)) {
                  const newHeight = `calc(306px - ${headerHeight}px)`;
                  if ($this.closest('.cart_footer-fixed').length) {
                      $('.cart_footer-fixed .sachets-wrapper').css('height', newHeight);
                  }
              }
              if ($('.icon-down-arrow-sachet').hasClass('icon-down-arrow-rotate')) {

                  $text.slideUp(250);
                  $('.icon-down-arrow-sachet').removeClass('icon-down-arrow-rotate');
                  $this.css('font-weight', 'normal');
                  $item.css('border', '');
                  $this.css('border', '1px solid rgba(78, 75, 74, 0.5)');
                  $this.removeClass('cart-open');
                  $('.cart_content--dav-desktop .overlay-minicart-backdrop').remove();
                  $('.cart_content--dav-desktop .cart_overflow').css({
                      'pointer-events': 'initial',
                      'user-select': 'initial'});
                  $('.cart_content--dav-desktop .minicart_header').css('pointer-events', 'initial');
                  if ($this.closest('.cart_footer-fixed').length) {
                      // $('header .top_bar').css('background-color', '#f9f9f9');
                      $('header .top_bar').css({
                          'background-color' : '#f9f9f9',
                          'overflow' : 'initial',
                          'pointer-events': 'initial',
                          'user-select': 'initial'
                      });
                      $('.dav-shoppingbag.dav-shoppingbag-cart .overlay-cart-backdrop').remove();
                      $('body').css ({
                          'overflow' : 'initial',
                          'pointer-events': 'initial',
                          'user-select': 'initial',
                          'touch-action' : 'initial'
                      });
                      $('html').css ({
                          'touch-action' : 'initial'
                      });
                  }

              } else {
                  $text.slideDown(250);
                  $('.icon-down-arrow-sachet').addClass('icon-down-arrow-rotate');
                  $this.css('font-weight', 'bold');
                  $this.css('border', '');
                  $item.css('border', '1px solid rgba(78, 75, 74, .5)');
                  $this.addClass('cart-open');
                  $('.cart_content--dav-desktop .js-cart_content__form').append('<div class="overlay-minicart-backdrop"></div>');
                  $('.cart_content--dav-desktop .cart_overflow').css({
                      'pointer-events': 'none',
                      'user-select': 'none'});
                  $('.cart_content--dav-desktop .minicart_header').css('pointer-events', 'none');
                  if ($this.closest('.cart_footer-fixed').length) {
                      // $('header .top_bar').css('background-color', 'rgb(136 136 136)');
                      // $('header .top_bar').css('transition: background-color 0.5s ease');
                      $('header .top_bar').css({
                          'background-color' : 'rgb(136 136 136)',
                          'transition' : 'background-color 0.5s ease',
                          'overflow' : 'hidden',
                          'pointer-events': 'none',
                          'user-select': 'none'
                      });
                      $('.dav-shoppingbag.dav-shoppingbag-cart').append('<div class="overlay-cart-backdrop"></div>');

                      $('body').css({
                          'overflow': 'hidden',
                          'pointer-events': 'none',
                          'user-select': 'none',
                          'touch-action' : 'none'
                      });
                      $('html').css ({
                          'touch-action' : 'none'
                      });
                      $('.cart_footer-fixed').css({
                          'pointer-events': 'all',
                          'overflow': 'auto'
                      });

                  }
              }

              let uniqueSachets = new Set();

              $('.faq-box__text.faq-box__text-sachet .sachets .sachet_list input:checked').each(function() {
                  uniqueSachets.add($(this).data('variant_id'));
              });
              // Array of unique values from the input list checked
              let checkedInput =[...uniqueSachets];

              
                  limit = 2;
                  modifySachet = '';
              

              if ($('.cart_item').length === 0) {
                  $('.sachet_list li input:not(:checked)').attr('disabled', $('.cart_item').length === 0);
              }
              if (checkedInput.length === limit && limit > 0) {
                  toggleElement('.faq-box__text-sachet-customer.customer-sachet', true, 'none');
                  toggleElement('.faq-box__text.faq-box__text-sachet .cart_promo_box', true, 'none');
                  $('.faq-box__text-sachet-customer.modify-sachet').text(modifySachet).css('display', 'block');
              } else {
                  toggleElement('.faq-box__text-sachet-customer.customer-sachet', true, 'block');
                  setTimeout(() => {
                      toggleElement('.faq-box__text.faq-box__text-sachet .cart_promo_box', true, 'flex');
                  }, 1000);
                  $('.faq-box__text-sachet-customer.modify-sachet').css('display', 'none');
              }

              return false;
          }

          if ($item.hasClass('show-minus')) {
          $text.slideUp(250);
          $item.removeClass('show-minus');
          $('button', $item).attr('aria-expanded', 'false');
          return false;
          }

          $('button', $item).attr('aria-expanded', 'true');

          $itemsText.slideUp(250);
          $items.removeClass('show-minus');

          setTimeout(function() {
          $text.slideDown(250);
          $item.addClass('show-minus');
          $item[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
          }, 300);
      });

      $(document).on('click', function(e) {
          var $target = $(e.target);

          // Check if click is out of faq-box
          if (!$target.closest('.faq-box__item.faq-box__item-sachet').length &&
              $target.is('.cart_content--dav-desktop .overlay-minicart-backdrop') &&
              $target.is('.dav-shoppingbag.dav-shoppingbag-cart .overlay-cart-backdrop')) {

              $itemsText.slideUp(250);
              $('.faq-box__item').css('border', '');
              $('.icon-down-arrow-sachet').removeClass('icon-down-arrow-rotate');
              $('.faq-box__item-title-sachet').css({
                  'border': '1px solid black',
                  'font-weight': 'normal'
              });
              $('faq-box__item.faq-box__item-sachet').removeClass('cart-open');
              $('.cart_content--dav-desktop .overlay-minicart-backdrop').remove();
              $('.cart_content--dav-desktop .cart_overflow').css({
                  'pointer-events': 'initial',
                  'user-select': 'initial'});
              $('.cart_content--dav-desktop .minicart_header').css('pointer-events', 'initial');

              if ($('faq-box__item.faq-box__item-sachet').closest('.cart_footer-fixed').length) {
                  // $('header .top_bar').css('background-color', '#f9f9f9');
                  $('header .top_bar').css({
                      'background-color' : '#f9f9f9',
                      'overflow' : 'initial',
                      'pointer-events': 'initial',
                      'user-select': 'initial'
                  });
                  $('.dav-shoppingbag.dav-shoppingbag-cart .overlay-cart-backdrop').remove();
                  $('body').css ({
                      'overflow' : 'initial',
                      'pointer-events': 'initial',
                      'user-select': 'initial'});
              }
          }

      });
  }
};

var doubleBox = {
    init: function(){
        var $doubleItems = $('.double-accordion__inside-item'),
            $doubleItemText = $('.double-accordion__inside-text');

        $doubleItemText.slideUp(0);

        $doubleItems.each(function(){
            var $el     = $(this),
                $insideTitle  = $el.find('.double-accordion__inside-title');

                $insideTitle.click(function(){
                    var $this = $(this);
                    $doubleItem = $this.parent(),
                    $doubleText = $this.next();

                if($doubleItem.hasClass('show-minus-inside')){
                    $doubleText.slideUp(250);
                    $doubleItem.removeClass('show-minus-inside');
                    return false;
                }
                $doubleItemText.slideUp(250);
                $doubleItems.removeClass('show-minus-inside');
                setTimeout(function(){
                    $doubleText.slideDown(250);
                    $doubleItem.addClass('show-minus-inside');
                }, 300);
            });
        });

    }
}

// Window load
$( window ).on("load",function() {
if(window.location.search == '?customer_posted=true'){
    Swal.fire({
        type: 'success',
        text: "¡Gracias por registrarte a nuestra Newsletter!",
        showCloseButton: false,
        showConfirmButton: false,
        timer: 2000,
        onClose: function() {
            $('#newsletter-overlay').modal('hide');
        }
    });
    if(window.location.hash === '#contact_form') {
        GTM.newsletter_position = 'footer';
    }
    if(window.location.hash === '#newsletter_modal') {
        GTM.newsletter_position = 'popup';
    }
    // GTM Newsletter tracking
    if(typeof dataLayer == 'object'){
        dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '10',
            'eventCategory': 'newsletter',
            'eventAction': 'subscribe',
            'eventLabel': GTM.newsletter_position
        });
    }
}
    // Davines newlsetter overlay
    

    // Autoscroll page
    if(typeof window.goToPosTarget !== 'undefined'){
        goToPos(window.goToPosTarget);
    }
});

// Check scroll page for mobile "back to top" toggle
var checkScroll = {
    init: function(){
        $( window ).on("scroll",function() {
            checkScroll.check();
        });
    },
    check: function(){
        var wh = $(window).height(),
            sc = $(window).scrollTop();

        $('.back-to-top').toggleClass('show-btt',(sc>wh));
    }
}

// Event handlers on cart scroll
var toggleCart = {
  init: function() {
      this.mainCart = $(".main [data-cart-form]");
      this.mainCartTOS = this.mainCart.find(".tos_agree--main");
      this.fixedFooter = $(".cart_footer-fixed");
      this.scrollableFooter = $(".cart_footer-scrollable");
      this.fixedFooterTOS = this.fixedFooter.find(".tos_agree--footer");

      this.footerHidden = false; // The fixed footer is initially visible

      this.throttled = false; // Check if the function is waiting

      this.handleTermsOfService();

      // Monitor scroll with throttling
      $(window).on("scroll", this.throttledCheck.bind(this));
  },

  throttledCheck: function() {
      if (this.throttled) {
          return;
      }

      this.throttled = true;

      // Run check after a short interval
      setTimeout(() => {
          this.check();
          this.handleTermsOfService();
          this.throttled = false; // Reset the status to allow further executions
      }, 100);
  },

  check: function() {

      if (this.scrollableFooter.length == 0) return;

      const headerHeight = $('header').innerHeight();
      const windowHeight = $(window).innerHeight();
      const footerRect = this.scrollableFooter[0].getBoundingClientRect();
      const footerHeight = footerRect.height;
      const footerTop = footerRect.top;
      const footerBottom = footerTop + footerHeight - headerHeight;

      const shouldBeHidden = footerBottom >= 0 && footerTop <= windowHeight;

      // Adjust visibility with transitions
      this.fixedFooter.toggleClass('hidden', shouldBeHidden);
      // check if the 'back to top' has entered the viewport
      this.fixedFooter.css('bottom', $('.back-to-top').hasClass('show-btt') ? $('.back-to-top').outerHeight() : 0);

      //trigger accordion click on scroll
      if (this.fixedFooter.hasClass('hidden')) {
          const fixedFooterAccordion = this.fixedFooter.find('.faq-box__item-title-sachet'); // Cerca dentro il footer fisso
          if (fixedFooterAccordion.hasClass('cart-open')) {
              fixedFooterAccordion.trigger('click');
          }
      } else {
          const scrollableFooterAccordion = this.scrollableFooter.find('.faq-box__item-title-sachet');
          if (scrollableFooterAccordion.hasClass('cart-open')) {
              scrollableFooterAccordion.trigger('click');
          }
      }
  },

  // Handle 'required' attribute for TOS elements
  handleTermsOfService: function() {
    if(this.mainCartTOS.length == 0 || this.fixedFooterTOS.length == 0) return;

    if($(window).width() > 768) {
      this.mainCartTOS.attr("required", true)
      this.fixedFooterTOS.attr("required", false);
    } else {
      if(this.fixedFooter.hasClass('hidden')){
        this.mainCartTOS.attr("required", true)
        this.fixedFooterTOS.attr("required", false);
      } else {
        this.mainCartTOS.attr("required", false)
        this.fixedFooterTOS.attr("required", true);
      }    
    }
  },
};

function html5RequireScrollFix(){
    var elements = document.querySelectorAll('input,select,textarea');
    var invalidListener = function(){ this.scrollIntoView(false); };

    for(var i = elements.length; i--;){
        elements[i].addEventListener('invalid', invalidListener);
    }
}


var linkAll = {

    init: function(){
        $('.linkFrom').each(function() {
            var elemToLink = $(this).parents('.linkTo');
            var pageLink = $(this).attr('href');
            var linkTarget = (typeof $(this).attr('target')!=='undefined') ?  $(this).attr('target') : '' ;
            var nobarba = $(this).hasClass('no-barba');
          if(pageLink !== undefined && pageLink!=='javascript:;') {
            elemToLink.addClass('pointer').click({myLink:pageLink, myTarget:linkTarget, nobarba:nobarba},function(e){
              e.preventDefault();
              if(e.data.myTarget==='_blank'){
                window.open(e.data.myLink);
              } else {
                if(typeof barbaJs !=='undefined' && !e.data.nobarba){
                  Barba.Pjax.goTo(e.data.myLink);
                } else {
                  location.href = e.data.myLink;
                }
              }
            });
          }
        });
      },

      /**
       * ELEMENTI PARZIALMENTE LINKABILI (aree diversificate all'interno dello stesso contenitore)
       */
      initParts: function(){
        var elems = $('.linkFromPart');
        var elemsLg = elems.length;
        if(elemsLg>0){
          var i=0;
          for (i; i<=elemsLg-1; i++) {
            var el = $(elems[i]);
            var pageLink = el.attr('href');
            if(pageLink !== undefined) {
              var blockWrap = el.parents('.linkWrap');
              var elemsToLink = $('.linkToPart',blockWrap);
              var nobarba = $(this).hasClass('no-barba');
              elemsToLink.addClass('pointer').click({pageLink:pageLink,nobarba:nobarba},function(e){
                if(typeof barbaJs !=='undefined' && !e.data.nobarba){
                  Barba.Pjax.goTo(e.data.pageLink);
                } else {
                  location.href = e.data.pageLink;
                }
              });
            }
          }
        }
      }
}

function setVhCssProp(){
    var vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', vh + 'px');
}

window.addEventListener('resize', function()  {
    setVhCssProp();
});

function modalVideoFix() {
    $('.bs-modal').on('hide.bs.modal', function (e) {
        var $target = $(e.target),
        $videoIframe = $target.find('iframe');


        if($videoIframe.length > 0){
            var tmp = $videoIframe.attr('src');
            $videoIframe.attr('src','');
            $videoIframe.attr('src',tmp);

        }
    });
}

/**
 * Quick buy (Add to cart in page) for listing items
 */
var listingQuickBuy = {
    init: function(){
        this.variantSelect();
        this.toggleBtn();
    },
    toggleBtn: function() {
       $(document).on('click', '.product-quickbuy__btn-toggle', function(){
           var  $el = $(this),
                $target = $el.parents('.product-quickbuy').find('.product-quickbuy__form-wrap');

                $el.parent().toggleClass('disable');
                $target.toggleClass('active');
       });
    },
    variantSelect: function(){

        // Updates prices on cta price based on variant selection
        $(document).on('change', '.product-list .product-buy-info .select select', function(){
            $el = $(this),
            $wrap = $el.parents('.product_form'),
            productData = $wrap.data('product'),
            $priceContainer = $wrap.find('.modal_price');

            if(typeof productData != 'undefined' && typeof productData.variants != 'undefined' && productData.variants.length > 0){
                for( i in productData.variants){
                    var variant = productData.variants[i];

                    if( variant.id == $el.val() ){
                        $priceContainer.find('.current_price .money').text(Shopify.formatMoney(variant.price, $('body').data('money-format')));
                        if(variant.compare_at_price != null && variant.compare_at_price > 0){
                            $priceContainer.find('.current_price .was_price').text(Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')));
                        }
                    }
                }
            }

        });
    }
}

function iOSBodyClass(){
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    $('body').toggleClass('is-iOS',iOS);

}

var becomeSalonForm = {
    salon_middleware_enabled: true,
    reg_selectors: {
        default : '#regions_default',
        it : '#regions_it',
        us : '#regions_us',
    },
    init: function(){
        this.form = $('.become-salon-form-wrapper form');
        this.regions('default');
        this.country();
        if (this.salon_middleware_enabled) this.submitOverride();
    },
    regions: function(key){
       for(i in this.reg_selectors){
           var show = (i==key);
           $(this.reg_selectors[i]).toggle(show);
           $(this.reg_selectors[i]).find('select, input').prop('disabled' , !show);
       }
    },
    country: function(){
        var self = this;
        $('.become-salon-form-wrapper #country_select').change(function(){
            var value = this.value.toLowerCase(),
                region = (Object.keys(self.reg_selectors).indexOf(value) !== -1) ? value : 'default' ;
            self.regions(region);
        });
    },
    submitOverride: function(){
        $(this.form).submit(function(e){

            var $el = $(this),
                data = $el.serializeArray(),
                middlewareData = {};

            e.preventDefault();
            $el.removeAttr("onsubmit"); //avoid shopify recaptcha injection
            $el.find('button[type="submit"]').prop("disabled", true);

            /* Map values for middleware */

            for(i in data){

                switch (data[i].name) {
                    case 'contact[email]':
                        mapKey = 'email';
                        break;

                    case 'contact[Teléfono]':
                        mapKey = 'phone';
                        break;

                    case 'contact[name]':
                        mapKey = 'name';
                        break;

                    case 'contact[surname]':
                        mapKey = 'surname';
                        break;

                    case 'contact[role]':
                        mapKey = 'role';
                        break;

                    case 'contact[Nombre del salón]':
                        mapKey = 'salon_name';
                        break;

                    case 'contact[Próxima apertura]':
                        mapKey = 'salon_next_opening';
                        break;

                    case 'contact[Página web del salón]':
                        mapKey = 'salon_website';
                        break;

                    case 'contact[Dirección del salón]':
                        mapKey = 'salon_address';
                        break;

                    case 'contact[country]':
                        mapKey = 'salon_country';
                        break;

                    case 'contact[Selecciona tu país]':
                    case 'contact[region_it]':
                    case 'contact[region_us]':
                        mapKey = 'salon_region';
                        break;

                    case 'contact[Ciudad]':
                        mapKey = 'salon_city';
                        break;

                    case 'contact[Código postal]':
                        mapKey = 'salon_zipcode';
                        break;

                    case 'contact[¿Cuántos peluqueros y coloristas están trabajando en el salón?]':
                        mapKey = 'salon_number_of_employees';
                        break;

                    case 'contact[Professional role]':
                        mapKey = 'salon_organization';
                        break;

                    case 'contact[¿Qué líneas de color estás usando actualmente?]':
                        mapKey = 'salon_color_lines_used';
                        break;

                    case 'contact[¿Qué líneas de retail estás usando actualmente ?]':
                        mapKey = 'salon_product_lines_used';
                        break;

                    case 'contact[contact reason]':
                        mapKey = 'way_to_find_out';
                        break;

                    case 'contact[contact-form-are_you_considering_davines]':
                        mapKey = 'considering_davines_as';
                        break;

                    case 'contact[contact-form-are_you_interested_in_davines]':
                        mapKey = 'considering_davines_for';
                        break;

                    case 'contact[contact-form-what_do_you_like_most_of_davines]':
                        mapKey = 'what_like_about_davines';
                        break;

                    case 'contact[privacy]':
                        mapKey = 'privacy';
                        break;

                    default:
                        mapKey = null;
                        break;
                }

                if(mapKey !== null ) {
                    if (data[i].value === 'true') data[i].value = true;
                    if (data[i].value === 'false') data[i].value = false;
                    middlewareData[mapKey] = data[i].value;
                }

            }

            middleware.contact_become_salon.register(middlewareData);

        });
    }
};

var editAccountInfo = {
    formSelector: '#change-customer-data',
    init: function(){
        this.middlewareSubmit();
    },
    middlewareSubmit: function(){
        var self = this;
        $(this.formSelector).submit(function(e) {
            e.preventDefault();
            var $form = $(this);
            self.middlewareRequestAccountData($form);
        })
    },
    middlewareRequestAccountData: function(form) {
        var $form = form;
        $form.find('button[type="submit"]').prop("disabled", true);
        var res = $form.serializeArray(),
                tag = [],
                action,
                name,
                last_name,
                phone,
                country,
                city;

        // Collect data for middleware
        for(i in res){
            switch (res[i].name) {

                case 'customer[birthday]':
                    tag.push('userBirthday_'+ res[i].value);
                    break;

                case 'customer[gender]':
                    tag.push('userGender_'+ res[i].value);
                    break;

                case 'customer[interest]':
                    tag.push(res[i].value);
                    break;

                case 'customer[first_name]':
                    name = res[i].value;
                    break;

                case 'customer[last_name]':
                    last_name = res[i].value;
                    break;

                case 'customer[full_phone]':
                    phone = res[i].value;
                    if (phone && phone.length > 0) {
                        tag.push('userPhoneNumber_'+ phone);
                    } else {
                        tag.push('userPhoneNumber_');
                    }
                    break;

                // case 'customer[sms]':
                //     if (phone && phone.length > 0) {
                //         tag.push('userAcceptSMS_true');
                //     } else {
                //         tag.push('userAcceptSMS_false')
                //     }
                //     break;

                case 'customer[city]':
                    country = res[i].value;
                    tag.push('userCity_'+ res[i].value.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, ''));
                    break;

                case 'customer[salon]':
                    city = res[i].value;
                    tag.push('userSalon_'+ res[i].value);
                    break;

            }
        }
        
        // Manually check the 'accepts_cookies' checkbox
        if ($form.find('input[name="customer[accepts_cookie]"]').is(':checked')) {
            tag.push('userAcceptCookie_true');
        } else {
            tag.push('userAcceptCookie_false');
        }

        // Manually check the 'accepts_marketing' checkbox
        if ($form.find('input[name="customer[accepts_marketing]"]').is(':checked')) {
          tag.push('userAcceptMarketing_true');
      } else {
          tag.push('userAcceptMarketing_false');
      }

        // Send data to middlweare
        middleware.changeAccount.sendData(tag.join(','), 'modify', name, last_name, phone, country, city, true);

        $form.find('button[type="submit"]').prop("disabled", false);
    }
}

function emptyCart() {
  $.ajax({
      url: '/cart/clear.js',
      dataType: 'json',
      cache: false,
      type: 'post'
  });
};

function refreshCart(cart) {
  minicart.handleInteractivity(false);

  if (cartPromo != null && typeof cartPromoCampaigns != 'undefined' && !cartPromo.promoLoaded) {
      cartPromo.init();
      if (cartPromo.promoLoaded) return;
  }

  $(".cart_count").empty();
  $cartBtn = $(".cart_count");
  var value = $cartBtn.text() || '0';
  var cart_items_html = "";
  var cart_action_html = "";
  var cart_savings_html = "";
  var $cart = $(".cart_content form");
  var discounted_price_total = 0;
  var total_savings = 0;
  var products_not_counted = 'sachet,promogift';
  products_not_counted = products_not_counted.split(',');

  // Recalculate cart_count including only real products:
  // - exclude product_type 'sachet' and 'promogift'
  // - exclude items with final_price == 0 (gifts)
  // - exclude product types listed in settings.products_not_counted
  var cart_count = cart.items.reduce(function (acc, item) {
      if (!item) return acc;
      var ptype = item.product_type || '';
      if (ptype === 'sachet' || ptype === 'promogift') return acc;
      if (item.final_price === 0) return acc;
      if (ptype !== '' && products_not_counted.indexOf(ptype) !== -1) return acc;
      return acc + (item.quantity || 0);
  }, 0);

  $cartBtn.text(value.replace(/[0-9]+/, cart_count));
  if($cartBtn.attr('data-label-count')) {
    $cartBtn.attr('aria-label', $cartBtn.attr('data-label-count').replace('X', value.replace(/[0-9]+/,cart.item_count)));
  }
  if (cart_count == 0 && cart.total_price == 0) {
      $('[data-cart-empty]').show();
      $('[data-cart-form]').hide();

      if ($('.cart_content--dav-desktop button.add_to_cart')) {
          $('.cart_content--dav-desktop button.add_to_cart').prop("disabled", true);
      }
      if ($('#checkout')) {
          $('#checkout').prop("disabled", true);
      }
      if (!jQuery.isEmptyObject(products_not_counted)) {
          emptyCart();
      }

      //when cart is empty, restore sachets initial state
      const $sachetInputs = $cart.find('.sachet_list li input');
      if ($sachetInputs.length) {
          $sachetInputs.prop('disabled', false);
          $sachetInputs.prop('checked', false);
      }

  } else {
      $('[data-cart-empty]').hide();
      $('[data-cart-form]').show();
      if ($('.cart_content--dav-desktop button.add_to_cart')) {
          $('.cart_content--dav-desktop button.add_to_cart').prop("disabled", false);
      }
      if ($('#checkout')) {
          $('#checkout').prop("disabled", false);
      }

      var otherItemsGroupHtml = "";

      // If at least one of the “show sachet” or “show gift” cart settings is checked
      
      //DEFAULT
      $.each(cart.items, function(index, item) {
          const lineItemVariantDetails = getProductVariantDetails(item.handle);
          let lineItemVariantIsAvailable = lineItemVariantDetails && lineItemVariantDetails.available;
          if (!lineItemVariantIsAvailable || 
              lineItemVariantDetails && item.quantity === 0 && item.product_type != "gift_card" && item.product_type != "sachet" && item.product_type != "promogift"
          ) {
              return; 
          }
          
          var line_id = index + 1;
          if (item.product_type != "sachet" && item.product_type != "promogift") {
              cart_items_html += '<li class="cart_item clearfix">' +
                  '<a class="cart_image-wrapper" href="' + item.url + '">';
              if (item.image) {
                  cart_items_html += '<div class="cart_image">' +
                      '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '">' +
                      '</div>';
              }
              cart_items_html += '</a>';
          } else {
              cart_items_html += '<li class="cart_item clearfix">' +
                  '<div class="cart_image-wrapper">';
              if (item.image) {
                  cart_items_html += '<div class="cart_image">' +
                      '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '">' +
                      '</div>';
              }
              cart_items_html += '</div>';
          }
          cart_items_html += '<div class="cart_item__title">';
          if (item.title.includes(" - ")) {
              const parts = item.title.split(" - ");
              const name = parts[0].trim();
              const size = parts[1]?.trim() || "";
              cart_items_html += '<div class="item_title">' + name + '<p class="item_size">' + size + '</p></div>';
          } else {
              cart_items_html += '<div class="item_title">' + item.title + '</div>';
          }

          if (item.properties) {
              $.each(item.properties, function(title, value) {
                  
                  if (title == 'gc_name_to') {
                      cart_items_html += '<div class="line-item">a ' + ': ' + value + '</div>';
                  }
                  
              });
          }
          cart_items_html += '</div>';
          cart_items_html += '<div class="right-container">';

          // Product removal button
          if (item.product_type == "sachet") {
              cart_items_html += '<button type="button" class="remove-sachet-cart_item" data-func="minus" data-variant_id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.product_type + '" product-size="' + item.variant_title + '" position="' + index + '"><img src="//es.davines.com/cdn/shop/t/12/assets/remove.svg?v=68580282936504704841765359213" class=""></button>';
          } else if (item.product_type == "promogift") {
              cart_items_html += '<button type="button" class="remove-product" data-func="minus" data-variant_id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.product_type + '" product-size="' + item.variant_title + '" position="' + index + '"><img src="//es.davines.com/cdn/shop/t/12/assets/remove.svg?v=68580282936504704841765359213" class=""></button>';
          } else {
              cart_items_html += '<button type="button" class="remove-product" data-func="minus" data-variant_id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.product_type + '" product-size="' + item.variant_title + '" position="' + index + '"><img src="//es.davines.com/cdn/shop/t/12/assets/remove.svg?v=68580282936504704841765359213" class=""></button>';
          }

          cart_items_html += '</div>';
          cart_items_html += '<div class="quantity-container">';

          // Add quantity
          if (item.product_type != "sachet") {
              if (item.product_type == "gift_card") {
                  cart_items_html += '<span class="clearfix quantity">Eliminar</span>' +
                      '<div class="left product-quantity-box">' +
                      '<span class="ss-icon product-minus js-change-quantity" data-func="minus" product-id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.type + '" position="' + index + '"><span class="icon-delete-gift"></span></span>' +
                      '<input type="number" min="0" class="quantity" style="display:none;" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '">' +
                      '</div>';
              } else if (item.product_type == "promogift") {
                  cart_items_html += '<span class="clearfix quantity free-gift">Cantidad</span>' +
                      '<div class="left product-quantity-box free-gift">' +
                      '<span class="ss-icon product-minus" data-func="minus" product-id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.product_type + '" product-size="' + item.variant_title + '" position="' + index + '"><span class="icon-minus"></span></span>' +
                      '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '">' +
                      '</div>';
              } else if(item.quantity > 0) {
                  cart_items_html += '<span class="clearfix quantity">Cantidad</span>' +
                      '<div class="left product-quantity-box">' +
                      '<span class="ss-icon product-minus js-change-quantity" data-func="minus" product-id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.product_type + '" product-size="' + item.variant_title + '" position="' + index + '"><span class="icon-minus"></span></span>' +
                      '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '">' +
                      '<span class="ss-icon product-plus js-change-quantity" data-func="plus" product-id="' + item.variant_id + '" product-name="' + item.product_title + '" product-price="' + item.price + '" product-brand="' + item.vendor + '" product-type="' + item.product_type + '" product-size="' + item.variant_title + '" position="' + index + '"><span class="minicart icon-plus"></span></span>' +
                      '</div>';
              }
          }

          cart_items_html += '<strong class="right price">';
          // Price logic
          
          $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              url: "/products/" + item.handle + ".js",
              success: function(data) {
                  var variant_id = item.variant_id;
                  var variant = $.grep(data.variants, function(v) {
                      return v.id == variant_id;
                  });
                  if (variant[0] && variant[0].compare_at_price > item.price) {
                      cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
                      discounted_price_total += item.price * item.quantity;
                      total_savings += variant[0].compare_at_price * item.quantity;
                  }
              }
          });
          

          if (item.final_price > 0) {
              cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
          } else {
              cart_items_html += '<span class="money">' + 'Free' + '</span>';
          }
          cart_items_html += '</strong>';
          cart_items_html += '</div>';

          if(item.selling_plan_allocation?.selling_plan?.name) {
            cart_items_html += '<div class="subscription-container">' + item.selling_plan_allocation.selling_plan.name + '</div>';
          }

          cart_items_html += '</li>';

      });
      

      /*cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>Subtotal</span>';*/

      if (total_savings > 0) {
          cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
              '<span>Ahorro total</span>';
      } else {
          cart_savings_html = "";
      }
  }

  cart_action_html += '<span>Subtotal</span>' + '<span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span>';
  var finalCartHtml = "";
  
  if ($('.js-cart_items').length > 0 && $('.js-cart_items').html() !== decodeHtmlEntities(cart_items_html)) {
      $('.js-cart_items').html(cart_items_html);
  }
  

  if ($('.js-cart_subtotal').length > 0 && $('.js-cart_subtotal').html() !== decodeHtmlEntities(cart_action_html)) {
      $('.js-cart_subtotal').html(cart_action_html);
  }
  if ($('.js-cart_savings').length > 0 && $('.js-cart_savings').html() !== decodeHtmlEntities(cart_savings_html)) {
      $('.js-cart_savings').html(cart_savings_html);
  }

  

  let totalCart = cart.total_price;
  let freeshippingLimit = 59 * 100;
  let html_content = "";
  let $mobile_menu_treshold = $('.mobile_menu__treshold .cart_freeshipping .text');

  if (totalCart >= freeshippingLimit) {
      html_content += "<span>¡Felicidades!</span><span>Obtienes envío estándar gratuito</span>";
  }
  else {
      html_content += "<span>¡Sólo te faltan " + Shopify.formatMoney((freeshippingLimit - totalCart), $('body').data('money-format')) + " para conseguir el envío gratuito!</span>";
  }
  $('.dav-minicart').each(function() {
      const $currentFreeShippingText = $(this).find('.cart_freeshipping .text');
      if ($currentFreeShippingText.length > 0 && $currentFreeShippingText.html() !== decodeHtmlEntities(html_content)) {
          $currentFreeShippingText.html(html_content);
      }
  });
  if (typeof $mobile_menu_treshold != 'undefined' && $mobile_menu_treshold.html() !== decodeHtmlEntities(html_content)) {
      $mobile_menu_treshold.html(html_content);
  }

  // SET PROGRESS BAR
  let $mobile_menu_progress = $('.mobile_menu__treshold .cart-shipping__wrapper');

  if (typeof $mobile_menu_progress != 'undefined') {

      let result = Math.min(100, Math.round((100 * totalCart) / freeshippingLimit));
      let remainingAmount = Shopify.formatMoney((freeshippingLimit - totalCart), $('body').data('money-format'));
      if (totalCart >= freeshippingLimit) {
          $('.cart-shipping__success').show();
          $('.cart-shipping__num-outer').hide();
      } else {
          $('.cart-shipping__success').hide();
          $('.cart-shipping__num-outer').show();
          $('.cart-shipping__num').text(remainingAmount);
      }

      $('.cart-shipping-threshold__progress').css('width', result + '%');
      if (totalCart >= freeshippingLimit) {
          $('.cart-shipping-threshold__progress').css('border-radius', '8px');
      } else {
          $('.cart-shipping-threshold__progress').css('border-radius', '8px 0px 0px 8px');
      }
      $('.cart-shipping__wrapper').addClass('visible');
  }

  // Adding this artificial delay to ensure the cart count update is noticeable for the end user 
  setTimeout(function() {
      minicart.handleInteractivity(true);
  }, 1000);

  $(document).trigger("originalRefreshCart");
}

function decodeHtmlEntities(input) {
  return $('<textarea/>').html(input).text();
}

//document ready
$(function() {
    storesData.init();
    redirectPopup.init();
    storesFooterMenu.init();
    html5RequireScrollFix();
    addBodyBrowserClass.init();
    checkScroll.init();
    toggleCart.init();
    $(window).on("resize", function() {
        toggleCart.init();
    });
    themeLazyLoad.init();
    anchorsMenu.init();
    linkAll.init();
    linkAll.initParts();
    setVhCssProp();
    modalVideoFix();
    listingQuickBuy.init();
    iOSBodyClass();
    becomeSalonForm.init();
    editAccountInfo.init();
    newsletterSection.init();
    hpSliderContent.init();
    relatedProductSlider.init();
    indexHeroSlider.init();
    promoBarSlider.init();
    wsbImageTextSlider.init();
    wsbRodaleSlider.init();
    wsbArticleBlock.init();
    wsbPrinciplesBlock.init();
    pdpCollectionProducts.init();

    $('#custom-language-switcher').change(function() {
        var $el = $(this);
        window.location.href = $el.val();
    });

    var wow = new WOW({
        offset: -100
    });
    wow.init();

    // Fill country select
    if(typeof window.populateContactCountrySelect === 'function'){
        populateContactCountrySelect();
    }

    // Init Material Design Form components
    if(typeof window.initMDCForms !== 'undefined'){
        MDCForms();
    }

    // Events filters mobile page
    if($('.events-list-container').length > 0){

        $('.events-list-container').waypoint(function(direction){
            $('.fixed-filters').toggleClass('up',(direction=='down'));
        },
        {
            offset: '90%'
        });
    }


    faqBox.init();
    doubleBox.init();


    var oldFlickityCreate = window.Flickity.prototype._create;

    window.Flickity.prototype._create = function(){
        var that = this;
        if(this.element.addEventListener){
            this.element.addEventListener('load', function(){
                that.onresize();
            }, true);
        }
        this._create = oldFlickityCreate;
        return oldFlickityCreate.apply(this, arguments);
    };

    objectFitImages();
    header.loadMegaMenu();
    header.init();
    
    utils.pageBannerCheck();
    slideshow.init();
    testimonial.init();
    videoSection.init();
    gallery.init();
    featuredPromotions.init();
    featuredCollectionSection.init();
    collectionSidebarFilter.init();
    cart.init();
    mapFunction.init();


    productPage.initializeQuantityBox();
    productPage.init();
    productPage.relatedProducts();

    recentlyViewed.init();

    if (window.location.pathname.indexOf('/collections/') !== -1) {
        Cookies.set("last_list", "category_listing");
    }

    if (window.location.pathname.indexOf('/search-results') !== -1) {
        Cookies.set("last_list", "search_result");
    }

    // Setup a timer
    var resizeTimeout;

    // Listen for resize events
    window.addEventListener('resize', function ( event ) {

        // If timer is null, reset it to 66ms and run your functions.
        // Otherwise, wait until timer is cleared
        if ( !resizeTimeout ) {
            resizeTimeout = setTimeout(function() {

                // Reset timeout
                resizeTimeout = null;

                // Run our resize functions
                if($(window).width() <= 798) {
                    cart.init();
                    if(typeof header !== 'undefined'){
                        header.unload();
                        header.init();
                    }
                }

            }, 66);
        }
    }, false);

    //Lightbox default options
    //https://fancyapps.com/fancybox/3/docs/#options
    $.fancybox.defaults.animationEffect = 'fade';
    $.fancybox.defaults.transitionEffect = 'fade';
    $.fancybox.defaults.hash = false;
    $.fancybox.defaults.infobar = false;
    $.fancybox.defaults.toolbar = false;
    $.fancybox.defaults.arrows = false;
    $.fancybox.defaults.loop = true;
    $.fancybox.defaults.smallBtn = true;
    $.fancybox.defaults.live = false;
    $.fancybox.defaults.zoom = false;
    $.fancybox.defaults.mobile.preventCaptionOverlap = false;
    $.fancybox.defaults.mobile.toolbar = true;
    $.fancybox.defaults.mobile.buttons = ['close'];
    $.fancybox.defaults.mobile.clickSlide = 'close';
    $.fancybox.defaults.mobile.clickContent = 'zoom';
    $.fancybox.defaults.afterLoad = function(instance, slide) {

             GTM.image_progression = slide.index +1;


        if (instance.current.type == 'image'){
            slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
        }
        if (instance.group.length > 1){

          slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" onclick="imgProgession();" href="javascript:;" data-fancybox-prev ><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" onclick="imgProgession();" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')

        }
    }

    //backwards compatibility with custom lightboxes
    $('.lightbox[rel="gallery"]').fancybox();

    //Search input hiding
    //get current input
    var currentValue = $(".search_form input[name='q']").val()
    //return amount without *
    if ($(".search_form input[name='q']").length > 0){
        $(".search_form input[name='q']").val( currentValue.replace('*', '') );
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body').on('change', '#blog_filter', function() {
        var url = $(this).val();
        window.location = url;
    });

    $('input, select, textarea').on('focus blur', function(event) {
        $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
    });


    $('body').on('click', '.go-back-to-top', function(){


        function getDuration(target) {
            var currentTop = $(window).scrollTop(),
            rate = 0.3,
            distance = Math.abs(currentTop - target);
            return distance * rate;
        }

        $("html, body").animate({
            scrollTop: 0
        }, getDuration(0));
    });


    $('body').on('click', '[data-reset-filters]', function(){
        collectionSidebarFilter.clearAllFilters();
    });

    $('body').on('click', '[data-clear-filter]', function(){
        var selectedOption = $(this).parents('.filter-active-tag');
        collectionSidebarFilter.clearSelectedFilter(selectedOption);
    });

    $('body').on('change', '.currencies', function(e) {
        $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
    });

    $('body').on('change', '.js-quick-shop select', function(e) {
        var currentVariant = $('.js-quick-shop select[name="id"]').val();
        if (currentVariant && globalQuickShopProduct){
            quickShop.updateVariant(currentVariant);
        }
    });

    

    var touchStartPos = 0;

    //Detecting swipe vs tap
    $(document).bind("touchstart", function (e) {
        touchStartPos = $(window).scrollTop();
    }).bind("touchend", function (e) {
        var distance = touchStartPos - $(window).scrollTop();
        if (distance > 20 || distance < -20) {
            e.preventDefault;
        }
    });

    $('body').on('click', '.sidebar .parent-link--false', function(e) {
        e.preventDefault();
        $menu = $(this).parent('li');
        $menu.find('.menu-toggle').toggleClass('active');
        $menu.find('ul').slideToggle();
    });

    

    if(window.location.pathname.indexOf('/comments') != -1) {
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
    }

    $('body').on('mouseenter', '.icon-search', function() {
        $('.search-terms').focus();
    });

    $('body').on('click', '.icon-search', function() {
        $('input.search-terms').focus();
    });

    $('body').on('click', '.search-submit', function() {
        $(this).parent().submit();
    });

    if ($(window).width() > 798) {
        $(".animate_right").waypoint(function() {
            $(this.element).addClass("animated fadeInRight");
        }, { offset: '70%' });
        $(".animate_left").waypoint(function() {
            $(this.element).addClass("animated fadeInLeft");
        }, { offset: '70%' });
        $(".animate_up").waypoint(function() {
            $(this.element).addClass("animated fadeInUp");
        }, { offset: '70%' });
        $(".animate_down").waypoint(function() {
            $(this.element).addClass("animated fadeInDown");
        }, { offset: '70%' });
    }

    //backwards compatibility with flexslider
    $('.slider, .flexslider').find('li').unwrap();
    $('.slider, .flexslider').flickity({
        pageDots: usePageDots,
        imagesLoaded: true,
        arrowShape: arrowSize,
        lazyLoad: 2
    });

    utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
    utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
    utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

    utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
    utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');
    utils.mobileAccordion('#mobile_menu', 'li.sublink > button.parent-link--false', 'li.sublink ul');

    utils.initializeTabs();
    utils.resizePrimaryButtons();
    faqAccordion.init();

    $(window).on('resize', function() {
        utils.resizePrimaryButtons();
    });

    //Sidebar toggle check
    if ($(window).width() <= 798) {
        utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
        utils.createAccordion('.footer_menu', 'h6', 'ul');
    }

    $('body').on('click', '.menu-toggle', function(e) {
        var $content = $(this).next('ul');
        $content.slideToggle();
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
    });

    if ($(window).width() >= 959) {
        var modal_width = '870px';
        if($(window).width() >= 1200 || $('html').hasClass('ie')) {
            modal_width = '1110px'
        }
    }

    
    if ($(window).width() > 798) {
        $('body').on('mouseenter', '.collection_swatches', function() {
            $('.swatch span', $(this)).each(function() {
                if($(this).data("image").indexOf("no-image") == -1) {
                    $('<img/>')[0].src = $(this).data("image");
                }
            });
        });
        $('body').on('mouseenter', '.swatch span', function() {
            if($(this).data("image").indexOf("no-image") == -1) {
                $(this).parents('.thumbnail').find('img:not(.secondary)').attr('src', $(this).data("image"));
                $(this).parents('.thumbnail').find('img:not(.secondary)').attr('srcset', $(this).data("image"));
            }
        });
    }
    

    //Terms of service settings for minicart
    

    


    

    $('.maps').click(function () {
        $('.maps iframe').css("pointer-events", "auto");
    });

    
    enableLoadMoreProducts();
    

    

    

    

    /*============================================================================
    Start of cart-related functionality
    ==============================================================================*/

    // EMPTY THE CART
    function emptyCart() {
        $.ajax({
            url: '/cart/clear.js',
            dataType: 'json',
            cache: false,
            type: 'post'
        });
    };

    function ajaxUpdateCart(lineID, quantity, parent) {
      quantity = parseInt(quantity);
      $.ajax({
          url: '/cart/change.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: { quantity: quantity, line: lineID },
          success: function (data) {

              if(typeof trigger_messages === "function"){
                  trigger_messages();
              }
              var lineIDIndex = lineID - 1;

              //check to see if there are correct amount of products in array
              if (typeof data.items[lineIDIndex] === "undefined"){
                  var updated_quantity = 0;
              } else {
                  var updated_quantity = data.items[lineIDIndex].quantity;
              }

              var total_discount = data.total_discount;

              if(total_discount == 0 && quantity > 0 && quantity != updated_quantity) {
                  if (updated_quantity == 1) {
                      items_left_text = "artículo restante";
                  } else {
                      items_left_text = "artículos restantes";
                  }

                  if(data.items[lineIDIndex].properties.max !== 'undefined'){
                      items_left_text = "maximum piece for this item";
                  }

                  $('.warning--quantity').remove();

                  var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
                  parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
                  parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
              }
              // } else if (parent.is('#cart_form')) {
              //     $("#cart_form").submit();
              // }
              refreshCart(data);


          }
      });
  }

  $('body').on("change", "#cart_form input.quantity", function() {
      ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
  });

  $('body').on("change", ".cart_content input.quantity", function() {
      ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
  });

    

    productPage.productSwatches();

    // Force both selects (sticky form + default form) to be equal in product page details
    $('.product-details .single-option-selector').on('change', function() {
        var select = $('.single-option-selector').parent().find('select');
        var value = $(this).val();
        $(select).each(function() {
            $(this).val(value);
        });
    });

});

/*============================================================================
Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

    switch (selectorIndex) {
        case 0:
        var key = 'root';
        var selector = $(parent + ' .single-option-selector:eq(0)');
        break;
        case 1:
        var key = $(parent + ' .single-option-selector:eq(0)').val();
        var selector = $(parent + ' .single-option-selector:eq(1)');
        break;
        case 2:
        var key = $(parent + ' .single-option-selector:eq(0)').val();
        key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
        var selector = $(parent + ' .single-option-selector:eq(2)');
    }

    var availableOptions = Shopify.optionsMap[key];
    $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
            $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
        }
        else {
            $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
        }
    });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++) {
        var variant = product.variants[i];
        if (variant.available) {
            // Gathering values for the 1st drop-down.
            Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
            Shopify.optionsMap['root'].push(variant.option1);
            Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
            // Gathering values for the 2nd drop-down.
            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
            // Gathering values for the 3rd drop-down.
            if (product.options.length === 3) {
                var key = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option3);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }
        }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
        Shopify.updateOptionsInSelector(1, parent);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
        return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
};

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};

$(document)
.on('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
        sliderBlock.select(blockId, $parentSection);
    }

    if($parentSection.hasClass('page-details-section')){
        if($('.map-section').length) {
            mapFunction.init();
        }
    }

    if ($parentSection.hasClass('cart-section')){
        if ($('.block__featured_collection').length){
            featuredCollectionSection.init();
        }
    }

    if ($parentSection.hasClass('product-template')){
        
    }

    utils.resizePrimaryButtons();

});

$(document)
.on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
        sliderBlock.deselect($parentSection)
    }

});

$(document)
.on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
.on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();

    

    if ($parentSection.hasClass('image-gallery-section')){
        gallery.init($parentSection);
    }

    if ($parentSection.hasClass('social-feeds-section')){
        $('.social-feeds-wrap').each(function (index, value) {

            social.twitter();

            var $target = $(this).find(".js-instafeed");
            instagram.loadContent({
                el: $target,
                clientID: $target.data('client-id'),
                limit: $target.data('count'),
                column: $target.data('column')
            });
        });
    }

    if ($parentSection.hasClass('faq-section')){
        faqAccordion.init();
    }

    if ($parentSection.hasClass('cart-section')){
        cart.init();
        if ($('.block__featured_collection').length){
            featuredCollectionSection.init();
        }
    }

    if ($parentSection.hasClass('featured-promotions-section')){
        featuredPromotions.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
        slideshow.init();
    }

    


    if ($parentSection.hasClass('testimonial-section')){
        testimonial.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
        productPage.initializeQuantityBox();
        productPage.productSwatches();
        productPage.init();
        
    }

    if($parentSection.hasClass('map-section')){
        mapFunction.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
        featuredCollectionSection.init();
    }

    if ($parentSection.hasClass('video-section')){
        videoSection.init();
    }

    if ($parentSection.hasClass('recently-viewed__section')){
        recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-template')){
        productPage.init();
        productPage.productSwatches();
        productPage.relatedProducts();
        recentlyViewed.init();
        
    }

    if ($parentSection.hasClass('article-template-section')){
        if(window.location.pathname.indexOf('/comments') != -1) {
            $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
        }
    }

    if ($parentSection.hasClass('collection-template-section')){
        collectionSidebarFilter.init();
    }

    if($parentSection.hasClass('contact-section')){
        mapFunction.init();
    }

    if ($parentSection.hasClass('search-template-section')){
        
        collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('header-section')){
        header.init();
        header.loadMegaMenu();
    }

    if ($parentSection.hasClass('mega-menu-section')){
        header.loadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
        featuredCollectionSection.init();
        videoSection.init();
        if($('.block__image_gallery').length) {
            gallery.init();
        };
        recentlyViewed.init();
    }

    if ($parentSection.hasClass('product-details-section')) {
        featuredCollectionSection.init();
        videoSection.init();
        mapFunction.init();
        if($('.block__image_gallery').length) {
            gallery.init();
        };
        recentlyViewed.init();
    }
});


$(document)
.on('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('header-section')){
        header.unload($target);
        header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('slideshow-section')){
        slideshow.unload($target);
    }

    if ($parentSection.hasClass('testimonial-section')){
        testimonial.unload($target);
    }

    if ($parentSection.hasClass('video-section')){
        videoSection.unload($target);
    }

    if ($parentSection.hasClass('search-section')){
        searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('product-template')){
        productPage.unload($target);
    }

    if ($parentSection.hasClass('mega-menu-section')){
        header.unloadMegaMenu();
    }

    if ($parentSection.hasClass('page-details-section')) {
        videoSection.unload($target);
    }

    if ($parentSection.hasClass('product-details-section')) {
        videoSection.unload($target);
    }

});

$(document)
.on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('social-feeds-section')){
        $('.social-feeds-wrap').each(function (index, value) {
            social.twitter();
        });
    }

    if ($parentSection.hasClass('mega-menu-section')){
        var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
        setTimeout(function() {
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
            $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
            header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
        }, 10);
    }

    if ($parentSection.hasClass('featured-collection-section')){
        featuredCollectionSection.unload($parentSection);
        featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
.on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('mega-menu-section')){
        var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

var storesData = {
    init: function(){
        this.getData();
    },

    getData: function(callaback){

        var stores = JSON.parse(localStorage.getItem('davines_stores'));
            expire = localStorage.getItem('davines_stores_expire');

        if(this.checkExpired(expire) || stores === null){

            $.ajax({
                url: 'https://davines.com/pages/stores?view=stores',
                method: 'GET',
                success: function (data) {

                    var setDate = new Date();
                    setDate.setHours(0,0,0,0);
                    setDate.setTime(setDate.getTime() + 15 * 86400000 );


                    localStorage.setItem('davines_stores' , data);
                    localStorage.setItem('davines_stores_expire',setDate);


                    // Callback in case we need the data we didn't had before
                    if(callaback){
                        switch (callaback) {
                            case 'popup':
                                redirectPopup.showModal();
                                break;

                            case 'footerSelect':
                                storesFooterMenu.show();
                                break;
                        }

                    }

                },
                error: function(data) {
                    console.warn(data)
                }
            });

        }
    },

    checkExpired: function(expire){

        var ret = false;

        if(expire !== null){

            var a = Date.parse(expire),
                b = new Date().setHours(0,0,0,0),
                diff = a-b,
                days = Math.ceil( diff / (1000 * 3600 * 24));


                if(days<=0) ret = true;
        }
        return ret;
    }
}

var storesFooterMenu = {

    html: '<select id="custom-language-switcher" aria-label="language-switcher"><option value="https://world.davines.com/">International</option>###CONTENT###</select></div>',
    storeCountryCode: 'es',

    init: function() {
        this.show();
    },
    show: function(){

        var storesLi = '',
            stores = JSON.parse(localStorage.getItem('davines_stores')),
            $wrap = $('#dav-lang-switcher'),
            selectActive = true;

        if(!selectActive) return false;

        // If we don't have the data, call the ajax, fill local storage and then come back again
        if(stores === null) {
            storesData.getData('footerSelect');
            return false;
        }

        var countries = stores.countries;

        for(i in countries){
            var s = countries[i];
                flag = stores.baseurl.replace('_international','_'+s.iso2),
                name = (typeof s.locale != 'undefined' && typeof s.locale[this.iso2] != 'undefined') ? s.locale[this.iso2] : s.name,
                active = (this.storeCountryCode == s.iso2) ? ' selected' : '';

                // We show only Countries with property set to true
                // we also hide the store we are browsing
                if(!s.show_select) continue;

                storesLi+= '<option value="'+ s.url +'"'+ active +'>'+ name +'</option>';
        }

        var html = this.html.replace('###CONTENT###',storesLi);
        $wrap.append(html);

        // Activate plugin for internal search
        $wrap.find('select').selectize({
            onChange : function(value){
                if(value != '') window.location.href = value;
            }
        });


    }
}

var redirectPopup = {

    selector: '#modalRedirect',
    iso2: (typeof storeIso != 'undefined') ? storeIso : 'en',
    stores: {},
    geoData: null,
    countryCode: '',
    storeCountryCode: 'es',

    init: function(){

        if(Shopify.designMode === true) return; // Avoid this behavior for theme editor

        var poupActive = true,
            self = this,
            alreadyShown = Cookies.get('davines_store_modal'),
            redirectUrl = Cookies.get('davines_store_redirect');


        // If redirect cookie is set, and we are not already in the choose websiite let's redirect to the right one.
        

        if(typeof Geolizr != 'undefined'){

            Geolizr.getGeoData(function(geoData){

                self.geoData = geoData;
                self.countryCode = geoData.countryCode.toLowerCase();

                // If store is enabled and browsing country is not store shipping country we show the popup and we didn't already show the banner
                if(poupActive && self.countryCode != self.storeCountryCode && alreadyShown !== 'true' ){
                    self.showModal();
                }
            });





        }

    },

    showModal: function(){

        var title = "¡Parece que no estás navegando desde España!",
            text = "<p>Desde esta tienda solo puedes comprar dentro del territorio español. Si deseas comprar en otro país, selecciónalo de la lista a continuación.</p>",
            $modal = $(this.selector),
            storesLi = '',
            stores = JSON.parse(localStorage.getItem('davines_stores')),
            expire = parseInt(1);


        if(stores === null) {
            storesData.getData('popup');
            return false;
        }

        // Add general settings for Set cookie with custom timing :)
        Cookies.set('davines_store_modal', true , { expires: expire, domain: 'davines.com' });

        // Fill content
        $modal.find('.modal-text').append('<h4 class="modal-country__title">'+ title +'</h4>'+ text);

        var countries = stores.countries;

        for(i in countries){
            var s = countries[i];
                flag = stores.baseurl.replace('_international','_'+s.iso2),
                name = (typeof s.locale != 'undefined' && typeof s.locale[this.iso2] != 'undefined') ? s.locale[this.iso2] : s.name,
                active = (this.countryCode == s.iso2) ? ' active' : '';
                shopIcon = (s.shop) ? '<img src="//es.davines.com/cdn/shop/t/12/assets/ecomm-icon.svg?v=8834785459707722591640074305" class="modal-country__shop-icon">' : '' ;

            // We show only Countries with property set to true
            // we also hide the store we are browsing
            if(!s.show_select || s.iso2 == this.storeCountryCode) continue;

            storesLi+= '<li class="anim'+ active +'" data-url="'+ s.url +'"><span class="modal-country__shop-icon-wrap">'+ shopIcon +'</span><img src="'+ flag +'" alt="Davines shop '+ name +'" class="modal-country__flag"><span class="modal-country__name">'+ name +'</span></li>';
        }

        $modal.find('.country-list')
        .append('<li class="anim" data-url="https://world.davines.com/"><span class="modal-country__shop-icon-wrap"></span><img src="'+ stores.baseurl +'" alt="Davines shop international" class="modal-country__flag"><span class="modal-country__name">International website</span></li>')
        .append(storesLi);

        // Attach behaviors

        // Search countries
        $modal.find('input[name="country_search"]').keyup(function(e){
            var $el = $(this),
                val = $el.val();

            $modal.find('.country-list li').each(function(){
                var $this = $(this),
                    text = $this.find('.modal-country__name').text();

                if(typeof text == 'string'){
                    text = text.toLowerCase();
                    $this.toggleClass('hide' , text.indexOf(val) === -1);
                }
            });
        });

        // Countries
        $modal.find('.country-list li').click(function(){
            var $el = $(this);
            $el
            .addClass('active')
            .siblings()
            .removeClass('active');
        });


        // Cta
        $modal.find('.go-to-website').click(function(){
            var url = $modal.find('.country-list li.active').data('url');
            if(typeof url != 'undefined' && url != ''){
                
                if(window.location.pathname.indexOf('/products/') !== -1){
                    url = url.substring(0, url.length - 1);
                    url += window.location.pathname;
                }
                window.location.href = url;
            }
        });

        // Callbacks
        $modal.on('shown.bs.modal', function (e) {

            // Scroll to active country if present
            var $activeLi = $modal.find('.country-list li.active').first();

            if($activeLi.length == 1){

                    // Adjust calculation as first element seems not to have top 0
                    var scrollTop = $activeLi.position().top - $modal.find('.country-list li').first().position().top;

                    $modal.find('.country-list').animate({
                        scrollTop: scrollTop
                    }, 150 );

            }
        });

        // Finally show modal
        setTimeout(function(){

                // Check if newsletter modal is open then we close it
            if($('#newsletter-overlay').length > 0){
                $('#newsletter-overlay').modal('hide');
            }

            $modal.modal('show');
        }, 5000);

    }
}

var newsletterSection = {
    sectionSelector: '.newsletter_section--dav',
    formSelector: '.nw-to-middleware',
    nw_middleware_enabled: false,

    init: function(){
        this.layout();
        this.middlewareSubmit();
        this.eventListener();
    },
    eventListener: function (){
        var $btn = $(this.formSelector).find('button[type="submit"]');

        document.addEventListener('submitNewsletter', function () {
            $btn.prop("disabled", false);
        }, false);
    },
    middlewareSubmit: function(){
        let self = this;
        $(this.formSelector).submit(function(e) {
            if(self.nw_middleware_enabled) {
                e.preventDefault();
                var $form = $(this);
                middlewareRequest($form);
            } else {
                GTM.newsletter_position = 'footer';
                if($('#nw-radio-1').prop('checked')){
                    $('#contact-tags').val($('#contact-tags').val() + ',' + 'userType_consumer' );
                }else{
                    $('#contact-tags').val($('#contact-tags').val() + ',' + 'userType_stylist');
                }
            }
        })
    },
    layout: function(){
        if(this.nw_middleware_enabled) $(this.formSelector).attr("action", "javascript:;");
        var $container = $(this.sectionSelector);
        $container.find(".after-focus").hide();
        $(".button-nl").click(function() {
            $container.find(".after-focus").slideDown();
        });
    }
}

/* Prevent Conflict of Jquery libraries */
var $= jQuery.noConflict();



$('#checkout').click(function () {
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function checkCookie() {
        var user = getCookie("event_location");
        if (user != "") {
        } else {
            user = 'cart_page';
            if (user != "" && user != null) {
                setCookie("event_location", user, 365);
            }
        }
    }
    document.cookie = "event_location=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    checkCookie();
});

/* GTM */
  $(document).on('click', '#mini-cart-go-checkout', function () {

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }

      function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

      function checkCookie() {
        var user = getCookie("event_location");
        if (user != "") {

        } else {
            user = 'fast_checkout';
          if (user != "" && user != null) {
            setCookie("event_location", user, 365);
          }
        }
      }
      document.cookie = "event_location=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      checkCookie();
  });


  $(document).ready(function () {

    $('body').on('click', '#mobile_menu .parent-link--true', function() {
        $(this).toggleClass('active');
    });

    $('.main_nav .menu li.top-level-menu__item>a, #mobile_menu > li > a:not(.mobile_menu_bottom, .mobile_menu__anchor)').click(function (e) {

       var primary_menu_voice = $(this).text();

        if(typeof dataLayer == 'object' && !$(this).hasClass("active")){
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '08',
                'eventCategory': 'menu',
                'eventAction': GTM.formatString(primary_menu_voice),
                'eventLabel': GTM.formatString(primary_menu_voice),
                'SubmenuVoice': GTM.formatString(primary_menu_voice)
            });
        }

    });
    $('.dropdown_column__menu > ul > li > a').click(function () {
        var primary_menu_voice = $(this).parent().parent().parent().parent().parent().parent().parent().attr('data-dropdown');
        var secondary_menu_voice = $(this).parent().parent().parent().find('ul.dropdown_title').find('a').text();
        var sub_menu_voice = $(this).text().trim();

        if(typeof dataLayer == 'object'){
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '08',
                'eventCategory': 'menu',
                'eventAction': GTM.formatString(primary_menu_voice),
                'eventLabel': GTM.formatString(secondary_menu_voice),
                'SubmenuVoice': GTM.formatString(sub_menu_voice)
            });
        }

    });
    $('#mobile_menu li.mobile-mega-menu_block ul li > a').click(function () {
        var primary_menu_voice = $(this).parent().parent().parent().parent().parent().parent().attr('data-mobile-dropdown-rel');
        var secondary_menu_voice = $(this).parent().parent().parent().find('a:first').text().trim();
        var sub_menu_voice = $(this).text().trim();

        if(typeof dataLayer == 'object' && !$(this).hasClass("active")){
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '08',
                'eventCategory': 'menu',
                'eventAction': GTM.formatString(primary_menu_voice),
                'eventLabel': GTM.formatString(secondary_menu_voice),
                'SubmenuVoice': GTM.formatString(sub_menu_voice)
            });
        }

    });
    $('#mobile_menu ul li > a:not(.mobile_menu_bottom, .sublink-list a)').click(function () {
        var primary_menu_voice = $(this).parent().parent().parent().parent().attr('data-mobile-dropdown-rel');
        //var secondary_menu_voice = $(this).parent().parent().parent().find('ul.dropdown_title').find('a').text();
        var sub_menu_voice = $(this).text().trim();

        if(typeof dataLayer == 'object' && !$(this).hasClass("active")){
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '08',
                'eventCategory': 'menu',
                'eventAction': GTM.formatString(primary_menu_voice),
                'eventLabel': GTM.formatString(sub_menu_voice),
                'SubmenuVoice': GTM.formatString(sub_menu_voice)
            });
        }

    });

    // Desktop megamenu image
    $('.dropdown_column--image').click(function () {
        var eventLabelElment = $(this).find('.mega-menu__image-caption-text strong');
        var eventLabel = (eventLabelElment.length) ? eventLabelElment[0].textContent : 'no-label' ;
        var eventAction = $(this).parents('.mega-menu').data('dropdown');
        if (typeof dataLayer != 'undefined') {
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '08',
                'eventCategory': 'menu',
                'eventAction':  GTM.formatString(eventAction),
                'eventLabel': GTM.formatString(eventLabel),
                'SubmenuVoice': 'image'
            });
        }
    });

    // Mobile megamenu image
    $('.mobile-mega-menu__richtext').click(function () {
        var eventLabelElment = $(this).find('.title-mini_mobile strong');
        var eventLabel = (eventLabelElment.length) ? eventLabelElment[0].textContent : 'no-label' ;
        var eventAction = $(this).parents('.mobile-mega-menu').data('mobile-dropdown');
        if (typeof dataLayer != 'undefined') {
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '08',
                'eventCategory': 'menu',
                'eventAction':  GTM.formatString(eventAction),
                'eventLabel': GTM.formatString(eventLabel),
                'SubmenuVoice': 'image'
            });
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {

    function gtmPush() {
        /* verifico se l'utente sia riuscito a loggare */
        if (document.URL.indexOf("successful-registration") != -1) {
            /* se l'utente è loggato vado a fare la push a google tag manager */
            if (localStorage.getItem("interests") === null) {
                preferences = "success";
            } else {
                preferences = localStorage.getItem("interests");
            }

            if(typeof dataLayer == 'object'){
                dataLayer.push({
                    'event': 'GAevent',
                    'ss_event_id': GTM.getGtmRandomString(),
                    'eventID': '04',
                    'eventCategory': 'registration',
                    'eventAction': 'step3',
                    'eventLabel': preferences
                });
            }
            localStorage.removeItem("interests");
        }
    }

    gtmPush();
});





/* Ricerca nel sito pag 32 */


$('.header_search_form .search-submit, .search__container .search__button').click(function () {


    var research_word = localStorage.getItem('search_terms');


    if (research_word == '') {
        research_word = '*';
    }

    if(typeof dataLayer == 'object'){
        dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '11',
            'eventCategory': 'onsite_search',
            'eventAction': research_word
        });
    }

});


$('.dropdown .header_search_form .search-terms').on('keydown', function (e) {
    if (e.which == 13) {
        var research_word = localStorage.getItem('search_terms');

        if (research_word == '') {
            research_word = '*';
        }

        if(typeof dataLayer == 'object'){
            dataLayer.push({
                'event': 'GAevent',
                'ss_event_id': GTM.getGtmRandomString(),
                'eventID': '11',
                'eventCategory': 'onsite_search',
                'eventAction': research_word
            });
        }
    }
});



var imgProgession = function() {

    if(typeof dataLayer == 'object'){
        dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '33',
            'eventCategory': 'product',
            'eventAction': 'image',
            'eventLabel': GTM.image_progression ,
            'sku': GTM.variant_sku
        });
    }
}

$('.redactional-box__item').click(function() {
    var title = $(this).find('.redactional-box__title.dav-title-block').attr('gtm-image');
    if(typeof dataLayer == 'object'){
        dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '20',
            'eventCategory': 'home_story_highlights',
            'eventAction': GTM.formatString(title),
            'eventLabel': 'redactional_boxes'
        });
    }
});

$('.index-hero-slider .swiper-slide .banner').click(function() {
    var title = $(this).find('.subtitle').attr('gtm-attr');
    if(typeof dataLayer == 'object'){
        dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '20',
            'eventCategory': 'home_story_highlights',
            'eventAction': GTM.formatString(title),
            'eventLabel': 'slider'
        });
    }
});

$('body').on( "mousedown touchstart", ".ls-photo-wrapper, .instafeed-container", function() {
    var title = $(this).find('img').attr('alt');
    if(typeof dataLayer == 'object'){
        dataLayer.push({
            'event': 'GAevent',
            'ss_event_id': GTM.getGtmRandomString(),
            'eventID': '20',
            'eventCategory': 'home_story_highlights',
            'eventAction': 'blocco_ig',
            'eventLabel': 'blocco_ig'
        });
    }
});

if($('.promo_banner')[0] && $(window).width() <= 798){
    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 60) {
            $('.promo_banner-show .promo_banner').css('height', '0');
            $('.promo_banner-show .promo_banner').css('min-height', '0px');
        }else{
            $('.promo_banner-show .promo_banner').css('height', 'auto');
            $('.promo_banner-show .promo_banner').css('min-height', '30px');
        }
    });
}

if($('.homepage-mobile-search') && $(window).width() <= 1024){
    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop();
        if (scrollTop > 60) {
            $('.homepage-mobile-search').addClass('closeHomeSearch');
            $('#pagecontent').removeClass('hasHomeSearchOpen');
            $('.icon-search').show();
        }
    });
}

var hpSliderContent = {
    selector: '.box-homepage-collection',
    breakpoint: 768,
    stopInit: false,
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                if($(this).find('.swiper-container').hasClass('swiper-container-initialized')) return;

                productSliderHelper.initSlider(this, `${obj.selector}__products .swiper-container`);
            });
        }
    }
}

var relatedProductSlider = {
    selector: '.related-products',
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                if($(this).find('.swiper-container').hasClass('swiper-container-initialized')) return;

                productSliderHelper.initSlider(this, '.swiper-container');
            });
        }
    }
}

var indexHeroSlider = {
    selector: '.index-hero-slider',
    breakpoint: 768,
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                var nBlocks = $(this).data('nblocks');
                if($(this).find('.swiper-container').hasClass('swiper-container-initialized') || nBlocks <= 1 ) return;

                var autoplay = ($(this).data('autoplay') == true);
                var autoplayParams = false;
                if(autoplay) {
                    autoplayParams = {
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                        delay: $(this).data('autoplay-speed')
                    };
                }
                let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
                    init: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    autoHeight: true,
                    speed: 800,
                    loop: true,
                    centeredSlides: true,
                    watchSlidesVisibility: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    observer: true,
                    observeParents: true,
                    autoplay: autoplayParams,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    }
                });

                swiper.on('resize', function() {
                    /* do something */
                    swiper.init();
                });

                /* init Swiper */
                swiper.init();
                themeLazyLoad.init();
            });
        }
    }
};

$("body").on('click', 'button[type="submit"].gift-btn',function (event) {
    var textArea= $('#textareaProduct');
    var valueTextArea = $(textArea).val();
    const newValue = $('#textareaProduct').val().replace(/,/g, '');
    var email = $('#email');
    var confirmEmail = $('#confirm_email');
    var inputs = email.parents('form').find('[required]');

    var emptyOne = inputs.filter(function () {
        return $(this).val().trim() == '';
    });

    if(emptyOne.length != 0) {
        if (email.val().trim() != confirmEmail.val().trim()){
            event.preventDefault();
            email.addClass('gift-error');
            confirmEmail.addClass('gift-error');
        }
        else {
            email.removeClass('gift-error');
            confirmEmail.removeClass('gift-error');
        }
    }

    if (newValue.length > 228 || newValue !== valueTextArea) {
        event.preventDefault();
        textArea.addClass('textarea-error');
    }
    else {
        textArea.removeClass('textarea-error');
    }
});

var promoBarSlider = {
    selector: '.promo_banner',
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                var nBlocks = $(this).data('nblocks');

                if($(this).find('.swiper-container').hasClass('swiper-container-initialized') || nBlocks <= 1 ) return;

                var autoplay = ($(this).data('autoplay') == true);
                var autoplayParams = false;
                if(autoplay) {
                    autoplayParams = {
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                        delay: $(this).data('autoplay-speed')
                    };
                }
                let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
                    init: false,
                    slidesPerView: 1,
                    direction: 'vertical',
                    allowTouchMove: true,
                    autoHeight: true,
                    height: 25,
                    spaceBetween: 25,
                    speed: 800,
                    loop: true,
                    centeredSlides: true,
                    watchSlidesVisibility: true,
                    observer: true,
                    observeParents: true,
                    autoplay: autoplayParams
                });
                    swiper.init();
            });
        }
    }
};

$('.collection-description-bottom article').readmore({
    moreLink: '<a href="#">+ Leer más</a>',
    lessLink: '<a href="#">- Cerrar</a>',
    blockProcessed: function(element, collapsable) {
        element.addClass('article-closed');
    },
    beforeToggle: function(trigger, element, expanded) {
        if (!expanded) {
            element.addClass('article-open');
            element.removeClass('article-closed');
            element.attr('aria-expanded', true);
        } else {
            element.removeClass('article-open');
            element.addClass('article-closed');
            element.attr('aria-expanded', false);
        }
    }
});

$(document).ready(function() {
    // Accessibility: toggle product description with ARIA attributes and keyboard support
    $('.new-product__show-more').on('click keydown', function(e) {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).addClass('hide');
            $(this).siblings('.new-product__show-less').removeClass('hide');
            $('.new-product-description__show').addClass('show').attr('aria-expanded', 'true');
            $(this).focus();
        }
    });

    $('.new-product__show-less').on('click keydown', function(e) {
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            $(this).addClass('hide');
            $(this).siblings('.new-product__show-more').removeClass('hide');
            $('.new-product-description__show').removeClass('show').attr('aria-expanded', 'false');
            $(this).focus();
        }
    });
});

var wsbImageTextSlider = {
    selector: '.wsb-slider-img-text__wrapper-slider',
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                var nBlocks = $(this).data('nblocks');

                if($(this).find('.swiper-container').hasClass('swiper-container-initialized') || nBlocks <= 1 ) return;

                let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
                    init: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    autoHeight: false,
                    speed: 800,
                    loop: true,
                    centeredSlides: true,
                    watchSlidesVisibility: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    }
                });

                /* init Swiper */
                swiper.init();
                themeLazyLoad.init();
            });
        }
    }
};

var wsbRodaleSlider = {
    selector: '.wsb-rodale-slider__container',
    breakpoint: 798,
    stopInit: false,
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                var nBlocks = $(this).data('nblocks');

                if($(this).find('.swiper-container').hasClass('swiper-container-initialized') || nBlocks <= 1 ) return;

                let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
                    init: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    autoHeight: false,
                    speed: 800,
                    loop: true,
                    centeredSlides: false,
                    freeMode: false,
                    watchSlidesVisibility: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    }
                });
                swiper.on('resize', function() {
                    // do something
                    if($(window).width() > obj.breakpoint){
                        swiper.destroy();
                    }
                });

                // init Swiper
                if($(window).width() <= obj.breakpoint){
                    swiper.init();
                }

            });
        }
        if(!this.stopInit) {
            $(window).on('resize', function(){
                if($(window).width() <= obj.breakpoint){
                    obj.slider();
                }
            });
            this.stopInit = true;
        }
    }
}

var wsbPrinciplesBlock = {
    selector: '.wsb-article-wrap',
    breakpoint: 798,
    stopInit: false,
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                var nBlocks = $(this).data('nblocks');

                if($(this).find('.swiper-container').hasClass('swiper-container-initialized') || nBlocks <= 1 ) return;

                let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
                    init: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    autoHeight: false,
                    speed: 800,
                    loop: false,
                    centeredSlides: false,
                    freeMode: false,
                    // watchSlidesVisibility: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        dragSize: 200,
                        dragClass: 'swiper-scrollbar-drag',
                    }
                });
                swiper.on('resize', function() {
                    // do something
                    if($(window).width() > obj.breakpoint){
                        swiper.destroy();
                    }
                });

                // init Swiper
                if($(window).width() <= obj.breakpoint){
                    swiper.init();
                }

            });
        }
        if(!this.stopInit) {
            $(window).on('resize', function(){
                if($(window).width() <= obj.breakpoint){
                    obj.slider();
                }
            });
            this.stopInit = true;
        }
    }
}

var wsbArticleBlock = {
    selector: '.wsb-principles-inner-image',
    breakpoint: 798,
    stopInit: false,
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                var nBlocks = $(this).data('nblocks');

                if($(this).find('.swiper-container').hasClass('swiper-container-initialized') || nBlocks <= 1 ) return;

                let swiper = new Swiper(this.querySelector(`${obj.selector} .swiper-container`), {
                    init: false,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    autoHeight: false,
                    speed: 800,
                    loop: false,
                    centeredSlides: false,
                    freeMode: false,
                    // watchSlidesVisibility: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        dragSize: 200,
                        dragClass: 'swiper-scrollbar-drag',
                    }
                });
                swiper.on('resize', function() {
                    // do something
                    if($(window).width() > obj.breakpoint){
                        swiper.destroy();
                    }
                });

                // init Swiper
                if($(window).width() <= obj.breakpoint){
                    swiper.init();
                }

            });
        }
        if(!this.stopInit) {
            $(window).on('resize', function(){
                if($(window).width() <= obj.breakpoint){
                    obj.slider();
                }
            });
            this.stopInit = true;
        }
    }
}

$(".js-scroll-id").on('click', function(e) {
    var thisId = $(this).attr("href"),
        scrollOffset = 18;
    //scroll
    $("html,body").animate(
        {
        scrollTop: $(thisId).offset().top - scrollOffset
        },
        800
    );
    return false;
});

var pdpCollectionProducts = {
    selector: '.pdp-collection__products',
    init: function() {
        this.slider();
    },
    slider: function () {
        let obj = this;
        if($(`${this.selector}`).length > 0){
            $(`${this.selector}`).each(function(){
                if($(this).find('.swiper-container').hasClass('swiper-container-initialized')) return;

                productSliderHelper.initSlider(this, '.swiper-container');
            });
        }
    }
}

//Save phone number value
const triggerChangeInputPhone = function (inputElement) {
  setTimeout(() => {
  // Checks whether the input is within the change-customer form
  if (inputElement.closest('#change-customer-data')) {
      document.getElementById('telNo').dispatchEvent(new Event('change'));
      }
    // Checks whether the input is within the registration form
    else if (inputElement.closest('#register_form')) {
      document.getElementById('customerFullPhone').dispatchEvent(new Event('change'));
    }
    // Checks whether the input is within the footer newsletter form
    else if (inputElement.closest('.newsletter_section')) {
      document.getElementById('newsletterFullPhone').dispatchEvent(new Event('change'));
    }
    // Checks whether the input is within the modal newsletter form
    else if (inputElement.closest('#newsletter-overlay')) {
      document.getElementById('newsletterPopupFullPhone').dispatchEvent(new Event('change'));
    }
  }, 200);
};

document.addEventListener("DOMContentLoaded", function () {
    var review = document.querySelector('.loox-rating');
    if(review != null) review.innerHTML = review.innerHTML.replace(/&nbsp;/g, '');
})

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
      $('.sachets-accordion.hidden-until-loaded').removeClass('hidden-until-loaded');
  }, 1000);
});
